export default __webpack_public_path__ + "static/media/school-pin.091ad86f.svg";